// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.sticky-filters[data-v-22ba47ca] {\n  display: block;\n  width: 100%;\n  position: sticky;\n  top: 0;\n  left: 15px;\n  z-index: 100;\n}\n", ""]);
// Exports
module.exports = exports;
